export default "__VITE_ASSET__wllb7yBV__"